import React, { useState, useEffect } from 'react';
import Loader from '../Common/Loader';
// import { history } from '../../redux/store';
import constants from '../../constants';
import axios from 'axios';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
import { Link, useNavigate, useLocation,useParams } from 'react-router-dom'; 

const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const Add = (props) => {
  const navigate = useNavigate();
  const  {id, requestType } = useParams();
  const [name, setName] = useState('');
  const [parentId, setParentId] = useState('');
  const [permissions, setPermissions] = useState({});
  const [copyName, setCopyName] = useState('');
  const [copyPermissions, setCopyPermissions] = useState({});
  const [flag, setFlag] = useState(false);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [type, setType] = useState('');
  const [message, setMessage] = useState('');
  const [showUILoader, setShowUILoader] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [roleId, setRoleId] = useState('');
  // const [requestType, setRequestType] = useState(props.match.params.type);
  const [roleID,setRoleID] = useState(id);

  useEffect(() => {
    // const { id } = props.match.params;
    if (id) {
      setRoleId(id);
      editPermissions(id);
    } else {
      getPermissions();
    }
    // eslint-disable-next-line
  }, []);

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const getPermissions = () => {
    axios(serverUrl + 'roles/new', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    })
      .then(response => {
        if (response.status === 200) {
          setPermissions(response.data.permissions);
        } else {
          setFlag(true);
          setType('error');
          setMessage(response.data.message);
          setTimeout(() => setFlag(false), 5000);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const setPermissionsData = (data) => {
    let setResult = {};
    let getData = Object.assign({}, data);
    Object.keys(getData).forEach((item) => {
      let getSelectedRole = getData[item].filter((d) => d.assigned === true);
      setResult[item] = getSelectedRole;
    });
    return setResult;
  };

  const editPermissions = (id) => {
    axios(serverUrl + 'roles/edit', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { roleId: id }
    })
      .then(response => {
        if (response.status === 200) {
          if (requestType === 'copy_role') {
            let setData = JSON.parse(JSON.stringify(response.data.permissions));
            setName(response.data.name);
            setPermissions(response.data.permissions);
            setCopyName(response.data.name);
            setCopyPermissions(setPermissionsData(setData));
          } else {
            setName(response.data.name);
            setPermissions(response.data.permissions);
            setCopyPermissions(setPermissionsData(response.data.permissions));
            setParentId(response.data.parent_id);
          }
        } else {
          setFlag(true);
          setType('error');
          setMessage(response.data.message);
          setTimeout(() => setFlag(false), 5000);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const render_permissions = (val) => {
    if (requestType === 'copy_role') {
      return copyPermissions[val]?.map((p, id) => (
        <div key={id} className="form-check checkbox-xl">
          <input type="checkbox" className="form-check-input" onChange={e => update_permission(e, val, id)} checked={copyPermissions[val][id]['assigned']} />
          <label className="form-check-label text-capitalize">
            {p['name'].replace(/_/g, ' ')}
          </label>
        </div>
      ));
    } else {
      return permissions[val]?.map((p, id) => (
        <div key={id} className="form-check checkbox-xl">
          <input type="checkbox" className="form-check-input" onChange={e => update_permission(e, val, id)} checked={permissions[val][id]['assigned']} />
          <label className="form-check-label text-capitalize">
            {p['name'].replace(/_/g, ' ')}
          </label>
        </div>
      ));
    }
  };

  const getUserList = () => {
    // history.push('/roles');
  };

  const permissionList = (data) => {
    return Object.keys(data).map(val => (
      <div className="col-xs-12 col-md-4 marg_bottom10" key={val} >
        <div className="cover bg1 shwd1 marg_bottom10">
          <div className="cover pad_top_bot7 pad_lft_rht10">
            <div className="cover">
              <div className="row gutters-5">
                <div className="col-xs-12 col-sm">
                  <div className="ovr bld tu marg_bottom10">
                    <span title="Category name">{val}</span>{' '}
                  </div>
                </div>
              </div>
            </div>
            <div className="cover">
              <div className="row">
                <div className="col-xs-12 col-md pad_top_bot3">
                  {render_permissions(val)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const submitRoleData = () => {
    var regName = /^[a-zA-Z_ ]+$/;
    if (name === '' || name === null) {
      showMessage('error', 'Please enter role name');
    } else if (!regName.test(name)) {
      showMessage('error', 'Allow only charachers and underscore');
    } else if (!validatePermission(permissions)) {
      showMessage('error', 'Please select a role');
    } else {
      // const { handleSubmit } = props;
      axios(serverUrl + 'roles/create', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { role: { name, parent_id: parentId, permissions } }
      }).then(response => {
        if (response.status === 200) {
          getUserList();
        } else {
          setFlag(true);
          setType('error');
          setMessage(response.data.message.name[0]);
          setTimeout(() => setFlag(false), 50000);
        }
        handleSubmit(true);
        setShowUILoader(false);
      }).catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
    }
  };

  const submitCopyRoleData = () => {
    var regName = /^[a-zA-Z_ ]+$/;
    if (copyName === '' || copyName === null) {
      showMessage('error', 'Please enter role name');
    } else if (name === copyName) {
      showMessage('error', 'Child role name should not be same as parent role');
    } else if (validateChilePermission()) {
      showMessage('error', 'Child list of role  should not be same as parent role');
    } else if (!regName.test(name)) {
      showMessage('error', 'Allow only charachers and underscore');
    } else if (!validatePermission(copyPermissions)) {
      showMessage('error', 'Please select a role');
    } else {
    
      axios(serverUrl + 'roles/create', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { role: { name: copyName, permissions: copyPermissions, parent_id: props.match.params.id } }
      }).then(response => {
        if (response.status === 200) {
          getUserList();
        } else {
          setFlag(true);
          setType('error');
          setMessage(response.data.message.name[0]);
          setTimeout(() => setFlag(false), 50000);
        }
        handleSubmit(true);
        setShowUILoader(false);
      }).catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
    }
  };

  const updateRoleData = () => {
    var regName = /^[a-zA-Z_ ]+$/;
    if (name === '' || name === null) {
      showMessage('error', 'Please enter role name');
    } else if (!regName.test(name)) {
      showMessage('error', 'Allow only charachers and underscore');
    } else if (!validatePermission(permissions)) {
      showMessage('error', 'Please select a role');
    } else {
     
      axios(serverUrl + 'roles/update', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { role: { name, parent_id: parentId, permissions, roleId } }
      })
        .then(response => {
          if (response.status === 200) {
            getUserList();
          } else {
            setFlag(true);
            setType('error');
            setMessage(response.data.message.name[0]);
            setTimeout(() => setFlag(false), 50000);
          }
          handleSubmit(true);
          setShowUILoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowUILoader(false);
        });
    }
  };

  const handleCancel = () => {
    navigate('/roles');
  };

  const handleSubmit = () => {
    navigate('/roles');
  };

  const update_permission = (e, val, _i) => {
    if (requestType === 'copy_role') {
      let setData = JSON.parse(JSON.stringify(copyPermissions));
      setData[val][_i]['assigned'] = e.target.checked;
      setCopyPermissions(setData);
    } else {
      let setData = JSON.parse(JSON.stringify(permissions));
      setData[val][_i]['assigned'] = e.target.checked;
      setPermissions(setData);
    }
  };

  const updateRoleName = (e) => {
    let value = e.target.value;
    if (requestType === 'copy_role') {
      setCopyName(value);
    } else {
      setName(value);
    }
  };

  const allPermission = (e) => {
    const permissinList = requestType === 'copy_role' ? { ...copyPermissions } : { ...permissions };
    Object.keys(permissinList).forEach(list => {
      let modifyList = permissinList[list].map((val) => {
        val.assigned = e.target.checked;
        return val;
      });
      permissinList[list] = modifyList;
    });
    if (requestType === 'copy_role') {
      setCopyPermissions(permissinList);
    } else {
      setPermissions(permissinList);
    }
  };

  const validatePermission = (data) => {
    let result = false;
    Object.keys(data).forEach(list => {
      Object.keys(data[list]).forEach(val => {
        if (data[list][val]['assigned'] === true) {
          result = true;
        }
      });
    });
    return result;
  };

  const validateChilePermission = () => {
    let result = false;
    let p_count = 0;
    let c_count = 0;
    Object.keys(permissions).forEach(key1 => {
      Object.keys(permissions[key1]).forEach(key2 => {
        if (permissions[key1][key2]['assigned'] === true) {
          p_count++;
        }
      });
    });
    Object.keys(copyPermissions).forEach(ckey1 => {
      Object.keys(copyPermissions[ckey1]).forEach(pkey2 => {
        if (copyPermissions[ckey1][pkey2]['assigned'] === true) {
          c_count++;
        }
      });
    });
    if (p_count === c_count) {
      result = true;
    }
    return result;
  };

  const permition = () => (
    <div className="container">
      <div className="cover marg_bottom20 text-start">
        <div className="row">
          <div className="col-xs-12 col-md-6 marg_bottom15">
            <label className="marg_bottom5">
              Name <span className="color5">*</span>
            </label>
            <div className="frm border_all_1 border_color_1">
              <input
                type="text"
                name='name'
                className="input pad_lft_rht5"
                onChange={updateRoleName}
                value={name}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-2" >
            <div className='form-check checkbox-xl'>
              <input type="checkbox" className='form-check-input' name='all_permission' onChange={allPermission} />
              <label className="form-check-label text-capitalize"> All Permission</label>
            </div>
          </div>
        </div>
        <hr/>
        <div className="row">
          {(Object.keys(permissions).length > 0) ? permissionList(permissions) : ''}
        </div>
        <hr/>
        <div className="row">
          <div className="col-xs-12 col-md-2" >
            <input
              value={roleId ? 'Update' : 'Save'}
              className="btn2 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
              type="button" onClick={() => roleId ? updateRoleData() : submitRoleData()}
            />
          </div>
          <div className="col-xs-12 col-md-6" >
            <input
              value="Cancel"
              className="btn2 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
              type="button" onClick={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const copyPermition = () => (
    <div className="container">
      <div className="cover marg_bottom20">
        <div className="row">
          <div className="col-xs-12 col-md-6 marg_bottom15">
            <label className="marg_bottom5">
              <span className='bld'>Parent Role Name</span> : {name}
            </label>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-6 marg_bottom15">
            <label className="marg_bottom5">
              Name <span className="color5">*</span>
            </label>
            <div className="frm border_all_1 border_color_1">
              <input
                type="text"
                name="copy_name"
                className="input pad_lft_rht5"
                onChange={updateRoleName}
                value={copyName}
              />
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          {(Object.keys(copyPermissions).length > 0) ? permissionList(copyPermissions) : ''}
        </div>
        <hr/>
        <div className="row">
          <div className="col-xs-12 col-md-2" >
            <input
              value={'Save'}
              className="btn2 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
              type="button" onClick={submitCopyRoleData}
            />
          </div>
          <div className="col-xs-12 col-md-6" >
            <input
              value="Cancel"
              className="btn2 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
              type="button" onClick={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">
              {roleId ? 'Edit Role' : 'Add Role'}
            </div>
          </div>
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>
          {message}
        </div>
      ) : ''}
      <div className="container_fluid pad_lft_rht20 padtop25">
        {requestType === 'copy_role' ? copyPermition() : permition()}
      </div>
    </React.Fragment>
  );
};

export default Add;
